import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyPlacesMapBlock = loadable(() => import(/* webpackChunkName: "content/guestSitePlacesMap" */ '.'), 'PlacesMapBlock');
